;!function(){try{var e="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import { useSyncExternalStore } from 'react'

/**
 * The visitor's `prefers-reduced-motion` setting, read live.
 *
 * Reading the media query once, at mount, is the mistake this module exists to prevent: the setting
 * can be switched on while the page is open — from the OS, or from the accessibility shortcut a
 * visitor reaches for precisely because something on the page is moving — and a visual that only
 * asked at mount kept playing. Everything that starts motion from script asks here, and listens.
 */
const QUERY = '(prefers-reduced-motion: reduce)'

function media(): MediaQueryList | null {
  return typeof window === 'undefined' || !window.matchMedia ? null : window.matchMedia(QUERY)
}

/** Whether reduced motion is requested right now. `false` on the server. */
export function prefersReducedMotion(): boolean {
  return media()?.matches ?? false
}

/** Calls `listener` whenever the setting changes; returns the unsubscribe. */
export function onReducedMotionChange(listener: () => void): () => void {
  const query = media()
  if (!query) return () => {}
  query.addEventListener('change', listener)
  return () => query.removeEventListener('change', listener)
}

/**
 * The setting as React state. The server snapshot is `false`, so the first client render matches
 * the server's and hydration never disagrees; the real value arrives straight after.
 */
export function usePrefersReducedMotion(): boolean {
  return useSyncExternalStore(onReducedMotionChange, prefersReducedMotion, () => false)
}
